import { render, staticRenderFns } from "./pages-wrapper.vue?vue&type=template&id=5c5d978a&scoped=true&"
import script from "./pages-wrapper.vue?vue&type=script&lang=js&"
export * from "./pages-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./pages-wrapper.vue?vue&type=style&index=0&id=5c5d978a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d978a",
  null
  
)

export default component.exports